const state = {
  userinfo: null,
  activeMenu: {
    menu:null,
    name: null,
  },
  showLoginPop: false,
  siteInfo: null,
  showBackTop: false,
  showLogin: false,
  fromIndexCate: null,
};

// getters
const getters = {
  getUserinfo: (state, getters) => {
    return state.userinfo;
  },
  getCoursecate: (state, getters) => {
    return state.coursecate;
  },
  getActiveMenu: (state, getters) => {
    return state.activeMenu;
  },
  getSHowLoginPop: (state, getters) => {
    return state.showLoginPop;
  },
  getSiteInfo: (state, getters) => {
    return state.siteInfo;
  },
  getShowBackTop: (state, getters) => {
    return state.showBackTop;
  },
  getFromIndexCate: (state, getters) => {
    return state.fromIndexCate;
  },
  getShowLogin: (state, getters) => {
    return state.showLogin;
  }
};

// actions
const actions = {
  setUserinfo({ commit, state }, arg) {
    commit("updateUserinfo", arg);
  },
  setCoursecate({ commit, state }, arg) {
    commit("updateCoursecate", arg);
  },
  setActiveMenu({ commit, state }, arg) {
    commit("updateActiveMenu", arg);
  },
  setShowLoginPop({ commit, state }, arg) {
    commit("updateShowLoginPop", arg);
  },
  setSiteInfo({ commit, state }, arg) {
    commit("updateSiteInfo", arg);
  },
  setShowBackTop({ commit, state }, arg) {
    commit("updateShowBackTop", arg);
  },
  setFromIndexCate({ commit, state }, arg) {
    commit("updateFromIndexCate", arg);
  },
  setShowLogin({ commit, state }, arg) {
    commit("updateShowLogin", arg);
  }
};

// mutations
const mutations = {
  updateUserinfo(state, arg) {
    state.userinfo = arg;
  },
  updateCoursecate(state, arg) {
    state.coursecate = arg;
  },
  updateActiveMenu(state, arg) {
    state.activeMenu = arg;
  },
  updateShowLoginPop(state, arg) {
    state.showLoginPop = arg;
  },
  updateSiteInfo(state, arg) {
    state.siteInfo = arg;
  },
  updateShowBackTop(state, arg) {
    state.showBackTop = arg;
  },
  updateFromIndexCate(state, arg) {
    state.fromIndexCate = arg;
  },
  updateShowLogin(state, arg) {
    state.showLogin = arg;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/util/store/modules/SessionStates.js